import { usePostHttp } from "../../../../../hooks/http/http.hook";
import type { IBrands } from "./get-workspace.hook";

export interface IBody {
  name: string;
  description: string | null;
  logo: string;
}

interface IResponse {
  brand: IBrands;
}

export function useCreateWorkspaceHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/brand/brands",
  });
}
